// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25e2_","content":"styles_content__32Frn","checkbox":"styles_checkbox__1XJuf","checkboxLabel":"styles_checkboxLabel__10pzD"};